import { IconSearch } from "@tabler/icons-react";

export const VersionsSearch = ({
  searchTerm,
  onSearchChange,
}: {
  searchTerm: string;
  onSearchChange: (value: string) => void;
}) => {
  return (
    <div className="tw-relative tw-h-9 tw-px-3 tw-outline-1 tw-outline-blue-100 tw-w-52 tw-outline tw-rounded-lg tw-bg-white -sm:tw-w-full">
      <IconSearch className="tw-size-4 tw-text-blue-500 tw-absolute tw-top-1/2 -tw-translate-y-1/2 tw-left-3" />
      <input
        type="text"
        placeholder="Search"
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        className="tw-pl-6 tw-outline-none tw-w-full tw-h-full tw-rounded-t-lg tw-text-sm tw-font-normal tw-text-blue placeholder:tw-text-blue-500"
      />
    </div>
  );
};
